/**
 * Hash function creating a 53bit hash
 * Stolen from https://stackoverflow.com/a/52171480/4061620
 *
 * @param str the input string to be hashed
 * @param seed the seed to start from
 */
export function hash(str: string, seed = 0): string {
  let h1 = 0xdeadbeef ^ seed;
  let h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

  return `${4294967296 * (2097151 & h2) + (h1 >>> 0)}`;
}

/**
 * Creates a simple 32-bit hash
 * Taken from https://stackoverflow.com/a/7616484
 *
 * @param str the input string to be hashed
 */
export function numericHash(str: string): number {
  let hashNumber = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    const chr = str.charCodeAt(i);
    hashNumber = (hashNumber << 5) - hashNumber + chr;
    hashNumber |= 0; // Convert to 32bit integer
  }
  return hashNumber;
}
